import { useRef } from 'react';
import { ReactComponent as CloudUplodIcon } from 'assets/icon/cloud-upload.svg';
import { useTranslation } from 'react-i18next';

interface ICloudUploadProps {
  setFile: (data: React.ChangeEvent<HTMLInputElement>) => void;
  acceptedFile?: string;
  title?: string;
  isDisabled?: boolean;
}
const CloudUpload: React.FC<ICloudUploadProps> = ({
  setFile,
  acceptedFile = '',
  title = ' Upload Photo/Video',
  isDisabled = false,
}) => {
  const fileRef = useRef<HTMLInputElement | null>(null);
  const handleUploadFile = () => {
    const fileElement = fileRef.current;
    fileElement?.click();
  };
  const { t } = useTranslation();
  return (
    <div
      className="flex flex-wrap justify-center items-center w-full p-4 rounded-3 border-dashed border-2 border-divider2 cursor-pointer"
      onClick={() => handleUploadFile()}
    >
      <div className="flex justify-center items-center w-full">
        <CloudUplodIcon />
      </div>
      <input
        type="file"
        className="hidden"
        ref={fileRef}
        onChange={event => setFile(event)}
        accept={acceptedFile ? acceptedFile : '*'}
        disabled={isDisabled}
      />
      <label className="w-full text-sm font-bold text-center cursor-pointer">
        {title}
      </label>
      <label className="w-full text-xs font-regular text-center cursor-pointer">
        {t('FILE_SIZE')}
      </label>
    </div>
  );
};

export default CloudUpload;
